export default {
  header: {
    title: '💛 Geef het team een fooi',
    subtitle: '100% gaat naar het personeel',
  },
  buttons: {
    other: 'Anders',
    none: 'Geen',
  },
  summary_label: 'Fooi',
  form: {
    custom_tip: {
      validation: {
        max: '{{value}} is het maximale fooibedrag',
      },
    },
  },
};
